import React from "react";
import {FaCheck} from "react-icons/fa";
import {Link} from "react-router-dom";

export function ProductItem({name, price, features, url, display, token}) {


    return (
        <div className={"col bg-white border rounded p-4 m-3 d-flex flex-column   "} style={{minHeight:"55vh"}}>
            <h3 className={" my-2  "}>{name}</h3>


            <div className={"mb-5 "}>
                {
                    features.map(feature => (
                        <div className={"px-3"}>
                            <FaCheck size={16} className={"text-success"}/>
                            <label className={"ms-3 fs-5"}>
                                {feature}
                            </label>
                        </div>
                    ))
                }
            </div>

            <div className={"mt-auto row align-items-end border-top  p-0 pt-2"}>
                <div className={"col"}>
                    <p className={"fw-bold fs-4 m-0 p-0"}>{price},-</p>
                    <p className={"m-0 p-0"}>Per måned</p>
                </div>

                <div className={"col"}>
                {
                    !display ?
                        <Link to={"/purchase/"+token.id} className={"text-decoration-none"}>
                            <vipps-mobilepay-button
                                type="button"
                                brand="vipps"
                                language="no"
                                variant="primary"
                                rounded="true"
                                verb="buy"
                                stretched="false"
                                branded="true"
                                loading="false"></vipps-mobilepay-button>
                        </Link>
                        : null
                }
                </div>
            </div>
        </div>

    );


}